		<template>
			<div v-if="basicData" class="view-details-header bg-primary position-relative" >
				<div v-if="basicData.thumbnail" class="header-image"><img :alt="basicData.name" :src="basicData.thumbnail"></div>
				<div class="header-overlay" ></div>
				<div class="container container--narrow position-relative pdt-30 pdb-30">
					<div class="t-headline11 t-color-whiteHigh font-m">
						{{basicData.name}}
					</div>
					<div class="t-body6 t-color-whiteHigh font-r pdt-17 pdb-13">
						{{basicData.category.text}}{{basicData.category.child ? ' > ' + basicData.category.child.text : ''}}
					</div>
					<template v-if="basicData.levels.length" ></template>
					<div v-for="(level, index) in basicData.levels" :key="'div1'+index" class="t-body6 t-color-whiteHigh font-r pdb-12">
						{{level.text}} {{basicData.levels.length === index+1 ? '' : '/' }}
					</div>
					<div v-if="basicData.tags.length" class="mdc-chip-set banner--chip chip--outlined"  role="grid" >
						<div v-for="(tag, index) in basicData.tags" :key="'div'+index" class="mdc-chip " role="row">
							<div class="mdc-chip__ripple d-none"></div>
							<span role="gridcell">
								<span class="mdc-chip__text t-body4 font-r">#{{tag.name}}</span>
							</span>
						</div>
					</div>
					<div v-if="basicData.goods" class="d-flex align-items-baseline justify-content-between mgt-24" >
						<div v-if="basicData.goods.paymentPrice > 0" class="d-flex align-items-baseline pdb-24" >
							<div class="t-body6 pdr-4 t-color-whiteHigh">{{basicData.goods.currency.key || 'USD'}}</div>
							<div class="t-headline5 pdr-8  t-color-whiteHigh font-b">{{$n(basicData.goods.paymentPrice)}}</div>
							<div v-if="basicData.goods.paymentPrice !== basicData.goods.price"  class="t-body1 t-color-whiteMedium t-line-through-red" >{{$n(basicData.goods.price)}}</div>
							<!-- <div class="t-body1 t-color-whiteMedium t-line-through-red">22,000</div> -->
						</div>
						<div v-else class="d-flex align-items-baseline pdb-24" >
							<div class="t-headline5 pdr-8  t-color-whiteHigh font-b"> {{$t('664')}}</div>
	  
							<!-- <div class="t-body1 t-color-whiteMedium t-line-through-red">22,000</div> -->
						</div>
						<div class="t-body1 t-color-whiteMedium font-r">{{setRegisterRestrictText}}</div>
					</div>

					<template v-if="basicData.goods" >
						<button v-for="(action, index) in basicData.actions" :key="index"
							:class="!action.enable ? 'bg-disableBtn':'bg-mainBtn t-color-mainBtnText'"
							:disabled="!action.enable" class="mdc-button mdc-button--raised  w-full"
							tabindex="0"
							@click="actionDegree(action)" @keypress="actionDegree(action)">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">
								{{basicData.goods.paymentPrice > 0 ? 
										$t(action.translate, {str : $moment(action.translateParams.registerStart).format('L')}) :
										!action.enable &&  action.id == 'END_ENTER' ? $t('670') : !action.enable &&  action.id == 'BEFORE_ENTER' ? $t('668', {str : $moment(action.translateParams.registerStart).format('L')}) :$t('665')
								}}
							</span>
						</button>
					</template>
				</div>
			</div>
</template>
<script>
/**
 * 차수 상세 헤더 컴포넌트(degree view header component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import httpService from '@/api/httpService'
import loginApi from '@/api/loginApi.js'
import degreeApi from '@/api/degreeApi.js'
import salesApi from '@/api/salesApi.js'
import {MDCRipple} from '@material/ripple'
import {MDCChipSet} from '@material/chips';

export default {
	data() {
		return {
			degreeId: null
		}
	},
	props: ['basicData'],

	computed: {
		// 정원 정보 노출(set register restrict)
		setRegisterRestrictText() {
			return this.basicData.capacity.registerRestrict.value === 'UNLIMITED_NUMBER' ? 
					'' :
					this.$t('605', {str1: this.basicData.capacity.learnerCount, str2: this.basicData.capacity.restrictCount})
		}
	},

	mounted() {
		this.degreeId = this.$route.params.degreeId
		this.setMaterialUi()
		const chipSetEl = document.querySelector('.mdc-chip-set');
		const chipSet = new MDCChipSet(chipSetEl);
	},

	methods: {
		// 버튼 유효성 체크(validation button)
		actionDegree(action) {
			if (localStorage.getItem('token')) {
				// check auth token
				loginApi.validToken().then((response) => {
					this.setAction(action)
				}).catch((err) => {
					this.moveLogin()
				})
			} else {
				this.moveLogin()
			}
		},

		//로그인 이동(move login)
		moveLogin() {
			const loginPath = `/login?redirectPath=${encodeURIComponent(this.$route.fullPath)}`
			this.$confirm({
					content: this.$t('934'), //'로그인 후 구매가 가능합니다. 로그인 하시겠습니까?',
					accept: this.$t('935'),
					cancel: this.$t('936')

				}).then(() => {
				}).catch(() => {                        
					this.$router.push(loginPath)
				})
		},

		// 구매정보 조회(get Purchased history)
		getSalesGoodsPurchased() {
			return new Promise((resolve, reject) => {
				salesApi.salesGoodsPurchased({goodsId: this.basicData.goods.id}).then((response) => {
					let purchasedData = response.data.data
					resolve(purchasedData)
				}).catch((err) => {
				})  
			})
		},

		// 학습기간 조회(get learing status)
		getLearnPeriod() {
			return new Promise((resolve, reject) => {
				// 기간정보
				const params = {
					degreeId: this.degreeId
				}
				degreeApi.guestLearnOnlineViewPeriod(params).then((response) => {
					// this.periodData = response.data.data
					resolve(response.data.data.learning)
				}).catch((err) => {
					
				})
		
			})
		},

		
		// 버튼 동작 (button action)
		async setAction(action) {
			// ENTER / 수강신청/수강 신청 가능 할 때 추가 되는 정보로 수강신청 시 사용할 정보가 포함되어 있다.
			// ENTER_CANCEL / 수간신청 취소/수강 신청 취소 가능 할 때 추가 되는 정보로 수강 신청 취소 시 사용할 정보가 포함되어 있다.
			// AWAITER_ENTER / 대기자 신청하기/대기자 신청 가능 할 때 추가 되는 정보로 대기자 신청 시 사용할 정보가 포함되어 있다.
			// AWAITER_ENTER_CANCEL / 대기자 취소하기/대기자 신청 취소 가능 할 때 추가 되는 정보로 대기자 신청 취소 시 사용할 정보가 포함되어 있다.
			// BEFORE_LEARNING / 학습시작/학습 시작 가능 할 때 추가 되는 정보로 학습 시작 시 사용할 정보가 포함되어 있다.

			let confirmData = {}
		
			// action.id = 'AWAITER_ENTER_CANCEL'
			//alert('yes');

			switch (action.id) {
				case 'ENTER':
					let salesGoodsPurchasedList = await this.getSalesGoodsPurchased()
					
					let learnPeriod = await this.getLearnPeriod()
					let messageDate = {}

					let endDates
					let startDate = this.$moment(learnPeriod.start).format('L')
					let endDate = learnPeriod.unlimited ? this.$t('50013') : this.$moment(learnPeriod.end).format('l')
					let endDateFormat = learnPeriod.unlimited ? this.$t('50013') : this.$moment(learnPeriod.end).format('L')
					if(new Date(endDate)>=new Date('1/17/2038')){
							//console.log('if=>>>')
							endDates = this.$t('50013')
						} else {
							endDates = endDateFormat
						}
					if (this.basicData.goods.paymentPrice > 0) {    // is free
						messageDate = {
							title: this.$t('433'), //구매 전 확인
							content: this.$t('434', {str1: startDate, str2: endDates}) + '<br>' + this.$t('416'), //본 강의의 학습 기간은 19.07.01 ~ 19.08.31입니다.구매를 계속 진행하시겠습니까?
							accept: this.$t('436'), //계속
							cancel: this.$t('435') //취소
						}
					}else {
						messageDate = {
							title: this.$t('980'), //수강신청 전 확인
							content: this.$t('981', {str1: startDate, str2: endDates}) + '<br>' + this.$t('982'), //본 강의의 학습 기간은 19.07.01 ~ 19.08.31입니다.구매를 계속 진행하시겠습니까?
							accept: this.$t('984'), //계속
							cancel: this.$t('983') //취소
						}

					}

					// console.log('salesGoodsPurchasedList', salesGoodsPurchasedList, learnPeriod, messageDate)

					this.$confirm(messageDate).then(() => {
						//console.log('this.$route.query',this.$route.query)
						let queryPram = this.$route.query;
						queryPram.fetchType='LEARN';
						
						localStorage.setItem('productId',this.basicData.id)

						if (salesGoodsPurchasedList.length) {
							this.$router.push({
								name: 'SalesDuplicate', 
								params: {goodsid: this.basicData.goods.id}, 
								query: queryPram
							})
							return false
						}

						this.$router.push({
							name: 'SalesInformation', 
							params: {goodsid: this.basicData.goods.id}, 
							query: queryPram
						})

					}).catch(() => {

					})

					break
				case 'ENTER_CANCEL':
					confirmData = {
						title: this.$t('50001'), //'수강신청 취소',
						content: this.$t('50002'), //'수강신청을 취소하시겠습니까?',
						accept: this.$t('939'),
						cancel: this.$t('940')
					}
					this.$confirm(confirmData).then(() => {
						this.enterCancel()
					}).catch(() => {})
					break
				case 'AWAITER_ENTER':
					confirmData = {
						title: this.$t('937'), //'대기자 신청',
						content: this.$t('938'), //'현재 수강인원이 가득차 있습니다. 대기자 신청을 하시겠습니까?',
						accept: this.$t('939'),
						cancel: this.$t('940')
					}
					this.$confirm(confirmData).then(() => {
						this.awaiterEnter()
					}).catch(() => {})
					break
				case 'AWAITER_ENTER_CANCEL':
					confirmData = {
						title: this.$t('941'), //'대기자 신청 취소',
						content: this.$t('942'), //'대기자 신청을 취소하시겠습니까?',
						accept: this.$t('943'),
						cancel: this.$t('944')
					}
					this.$confirm(confirmData).then(() => {
						this.awaiterEnterCancel()
					}).catch(() => {})
					break
				case 'BEFORE_LEARNING':
					this.$router.push(`/learn/list?type=LEARNING`)
					break
			}
		},

		// 대기자 신청 확인(check awaiter application)
		awaiterEnter() {
			let confirmData = {}
			confirmData = {
				title: this.$t('50003'), //'대기자 신청정보 확인',
				content: this.$t('50004'), //'공석발생시 전달받을 정보를 확인해주세요.<br>연락처 : 01020118284 <br> Email : koica@emcast.com',
				accept: this.$t('50006'),   //확인
				cancel: this.$t('50005')    //내 정보 수정
			}
			this.$confirm(confirmData).then(() => {
				this.awaiterEnter()
			}).catch(() => {
				this.$router.push({
					name: 'DegreeEnterAwait', 
					query: this.$route.query, 
					params: this.$route.params})
			})
		},

		// 대기자 신청 취소(awaiter application cancel)
		awaiterEnterCancel() {
			// Todo
		},

		//수강 취소(enrollment cancel)
		enterCancel() {
			// Todo
		},
		moveToDegreeList(){
			let learnBack= localStorage.getItem('subjectlist','backtoSubject')
			let subjectId=localStorage.getItem('subjectId')
			let subjectTitle= localStorage.getItem('subjectTitle')
			if(learnBack=='backtoSubject'){
				this.$router.push('/subjects/'+subjectId+'?title='+subjectTitle)
			} else {
				this.$router.go(-1)
			}
			
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})

		},
	   
	}
}
</script>
